import { render, staticRenderFns } from "./UsersClientPrivileges.vue?vue&type=template&id=171af60a&scoped=true&"
import script from "./UsersClientPrivileges.vue?vue&type=script&lang=js&"
export * from "./UsersClientPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171af60a",
  null
  
)

export default component.exports